import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./aproposStyle.css";


//
class Apropos extends React.Component{
    render() {
        return(
            <div className="presentationStyle">
                <h2>A Propos de moi</h2>
                <p style={{color:"#b09f63"}}>
                    Site en cours de développement...
                </p>
                <p className=" presentation p-2">
                    Actuellement en poste de QA, principalement des tests d'intégration, d'API et web services, tests fonctionnels et automatisation des tests : 
                        API (sur Postman) ou des tests front (Selenium avec un intérêt pour Playwright).
                    J'essaie de rester à jour sur la partie développement front et back 
                </p>
            </div>
        )
    }
}
export default Apropos;
